import { Cluster, PublicKey } from '@solana/web3.js'

export const LOAN_LIST_SCANNER_TIMEOUT = 60

// minimum screen width required in order to display wallet connect button in top nav bar
export const NAV_BAR_SCREEN_MIN_WIDTH_FOR_WALLET_BUTTON = 768

// minimum screen width required to display loan list in rows
export const LOAN_LIST_SCREEN_MIN_WIDTH_FOR_ROWS_DISPLAY = 1024

// UI Only, this is not for the backend smart contract.
export const PYTH_SOLANA_CLUSTER_NAME: Cluster = 'devnet'

export const KONG_MINT_AUTHORITY_SEED = 'kong_mint'
export const BANANA_MINT_AUTHORITY_SEED = 'banana_mint'
export const PROGRAM_VAULT_SEED = 'PROGRAM_VAULT'

export const KONG_STATE_ACCOUNT_SIZE = 283
export const KONG_LOAN_ACCOUNT_SIZE = 257

export const CREATOR_AUTHORITY: PublicKey = new PublicKey(
  '4ZKXWewnacnm2ApTJC68DzoNHaJg6gtTXZA3LLumfMtX'
)

export const PROGRAM_CREATOR_AUTHORITY: PublicKey = new PublicKey(
  '9kyWPBeU9RnjxnWkkYKYVeShAwQgPDmxujr77thREZtN'
)

export const PROGRAM_STATE_ACCOUNT = new PublicKey(
  'EvcBDSzxPM5WjQjgZGiewFpyKW9cEAVGoQeBkRMZo7uU'
)

export const SPL_ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID: PublicKey = new PublicKey(
  'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'
)

export const BANANA_MINT = new PublicKey(
  '98ct6KjzotM4e6Hn2PdBhYTJfi7yYDBhxVjcC21H7oUF'
)

export const KONG_MINT = new PublicKey(
  'CY5mvkTFqgiHQd4Fbb5ykv6aKCpczJVbxWxFXpCZZCJc'
)

export const KONGS_HOARD = new PublicKey(
  'HADUDXZsxpv5Nb4M81EaAHh6VxkSKkuDtdUsPHXm3Sv9'
)

// PYTH
export const SOL_ORACLE_PRODUCT = new PublicKey(
  '3Mnn2fX6rQyUsyELYms1sBJyChWofzSNRoqYzvgMVz5E'
)

export const SOL_ORACLE_PRICE = new PublicKey(
  'J83w4HKfqxwcq3BEMMkPFSppX3gqekLyLJBexebFVkix'
)

export const BANANA_ORACLE_PRODUCT = new PublicKey(
  '5SSkXsEKQepHHAewytPVwdej4epN1nxgLVM84L4KXgy7'
)
export const BANANA_ORACLE_PRICE = new PublicKey(
  '5SSkXsEKQepHHAewytPVwdej4epN1nxgLVM84L4KXgy7'
)

export const KONG_ORACLE_PRODUCT = new PublicKey(
  '2ciUuGZiee5macAMeQ7bHGTJtwcYTgnt6jdmQnnKZrfu'
)
export const KONG_ORACLE_PRICE = new PublicKey(
  'EdVCmQ9FSPcVe5YySXDPCRmc8aDQLKJ9xvYBMZPie1Vw'
)

// Marinade
export const MARINADE_PROGRAM_ID = new PublicKey(
  'MarBmsSgKXdrN1egZf5sqe1TMai9K1rChYNDJgjq7aD'
)

export const MARINADE_STATE_ID = new PublicKey(
  '8szGkuLTAux9XMgZ2vtY39jVSowEcpBfFfD8hXSEqdGC'
)

export const MSOL_MINT: PublicKey = new PublicKey(
  'mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'
)

export const MSOL_MINT_AUTH: PublicKey = new PublicKey(
  '3JLPCS1qM2zRw3Dp6V4hZnYHd4toMNPkNesXdX9tg6KM'
)

export const SOL_LEG: PublicKey = new PublicKey(
  'UefNb6z6yvArqe4cJHTXCqStRsKmWhGxnZzuHbikP5Q'
)

export const MSOL_LEG: PublicKey = new PublicKey(
  '7GgPYjS5Dza89wV6FpZ23kUJRG5vbQ1GM25ezspYFSoE'
)

export const MSOL_LEG_AUTHORITY_INFO: PublicKey = new PublicKey(
  'EyaSjUtSgo9aRD1f8LWXwdvkpDTmXAW54yoSHZRF14WL'
)

export const RESERVE_PDA_INFO: PublicKey = new PublicKey(
  'Du3Ysj1wKbxPKkuPPnvzQLQh8oMSVifs3jGZjJWXFmHN'
)

export const MSOL_TREASURY: PublicKey = new PublicKey(
  '8ZUcztoAEhpAeC2ixWewJKQJsSUGYSGPVAjkhDJYf5Gd'
)

// END Marinade

export const RAD_ID = new PublicKey(
  '2vLPCe92GpHKJRGDp9GjZRzAyeLh6RtW1ACAi9n4Fa1u'
)

export const SYSTEM_PROGRAM_ID = new PublicKey(
  '11111111111111111111111111111111'
)

export const SOLANA_TOKEN_ID = new PublicKey('11111111111111111111111111111111')
export const RENT_PROGRAM_ID = new PublicKey(
  'SysvarRent111111111111111111111111111111111'
)
export const CLOCK_PROGRAM_ID = new PublicKey(
  'SysvarC1ock11111111111111111111111111111111'
)
export const SOL_MINT = new PublicKey('11111111111111111111111111111111')
